import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

import CustomForm from "../../../helper-components/form/CustomForm";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter";

import ResourcesTable from "./components/ResourcesTable";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The resources page.
 */
export default function Resources(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().RESOURCES_TITLE} subtitle={getLanguage().RESOURCES_SUBTITLE} icon={<DescriptionIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <ResourcesTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/transcripts`,
                            title: "Transcripts",
                            variant: "outlined",
                            icon: <TextFieldsIcon />,
                            className: "tour-resources-7"
                        },
                        {
                            path: `/database/quotes`,
                            title: "Quotes",
                            variant: "outlined",
                            icon: <FormatQuoteIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
